import { referralRepository } from './repository';
import ReferralServiceImpl from './service/ReferralServiceImpl';

const referralService = new ReferralServiceImpl(referralRepository);

export { referralService };
